import React, { Component } from "react";
import { Link } from "react-router-dom";
import Joi from "joi-browser";
import Input from "./input";
import Select from "./select";

class Form extends Component {
  state = {
    data: {},
    errors: {}
  };

  validate = () => {
    const options = { abortEarly: false };
    const { error } = Joi.validate(this.state.data, this.schema, options);

    if (!error) return null;

    const errors = {};
    for (let item of error.details) errors[item.path[0]] = item.message;
    return errors;
  };

  validateProperty = ({ name, value }) => {
    const obj = { [name]: value };
    const schema = { [name]: this.schema[name] };
    const { error } = Joi.validate(obj, schema);
    return error ? error.details[0].message : null;
  };

  handleSubmit = e => {
    e.preventDefault();

    const errors = this.validate();
    this.setState({ errors: errors || {} });
    if (errors) return;

    this.doSubmit();
  };

  handleChange = ({ currentTarget: input }) => {
    const errors = { ...this.state.errors };
    const errorMessage = this.validateProperty(input);
    if (errorMessage) errors[input.name] = errorMessage;
    else delete errors[input.name];

    const data = { ...this.state.data };
    data[input.name] = input.value;
    this.setState({ data, errors });
  };

  renderButton(label, className) {
    const innerText =
      label.indexOf("fa ") === 0 ? <i className={label} /> : label;

    return (
      <button disabled={this.validate()} className={className}>
        {innerText}
      </button>
    );
  }

  renderLink(to, label, className) {
    const innerText =
      label.indexOf("fa ") === 0 ? <i className={label} /> : label;

    return (
      <Link to={to} className={className}>
        {innerText}
      </Link>
    );
  }

  renderSelect(name, label, options, allowEmpty = false) {
    const { data, errors } = this.state;

    return (
      <Select
        name={name}
        value={data[name]}
        label={label}
        options={options}
        allowEmpty={allowEmpty}
        onChange={this.handleChange}
        error={errors[name]}
      />
    );
  }

  renderInput(name, label, hasFocus = false, type = "text", enabled = true) {
    const { data, errors } = this.state;

    return (
      <Input
        autoFocus={hasFocus}
        enabled={enabled ? "" : "disabled"}
        id={name}
        type={type}
        name={name}
        value={data[name] ? data[name] : ""}
        label={label}
        onChange={this.handleChange}
        error={errors[name]}
      />
    );
  }

  handleCheckBoxChange = (e, name) => {
    const isChecked = e.target.checked;
    const { data } = this.state;
    data[name] = isChecked;

    this.setState({ data });
  };

  renderCheckBox(name, label) {
    const { data } = this.state;

    return (
      <div>
        <input
          type="checkbox"
          id={name}
          checked={data[name]}
          onClick={e => this.handleCheckBoxChange(e, name)}
        />
        <label htmlFor={name}>{label}</label>
      </div>
    );
  }
}

export default Form;



// WEBPACK FOOTER //
// ./src/components/common/form/form.jsx